module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Foreword#fm-1"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Foreword")]), _vm._v(" by Cornelius Plantinga")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Acknowledgments#fm-2"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm1"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#fm-3"
    }
  }, [_vm._v("Introduction: Baptismal Confidence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Part01#pt-1"
    }
  }, [_vm._v("Part One: Baptismal Identity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter01#ch-1"
    }
  }, [_vm._v("1. "), _c('span', {
    staticClass: "pad0"
  }, [_vm._v("The Script")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. "), _c('span', {
    staticClass: "pad0"
  }, [_vm._v("Kiddie-Pool Piety")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. "), _c('span', {
    staticClass: "pad0"
  }, [_vm._v("Drowning in a Coffin")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Part02#pt-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two: Baptismal Liturgy for Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. "), _c('span', {
    staticClass: "pad0"
  }, [_vm._v("Renouncing Evil")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. "), _c('span', {
    staticClass: "pad0"
  }, [_vm._v("An Ordained Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. "), _c('span', {
    staticClass: "pad0"
  }, [_vm._v("Baptismal Clothes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Part03#pt-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three: Baptismal Abuse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. "), _c('span', {
    staticClass: "pad0"
  }, [_vm._v("Identity Politics")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. "), _c('span', {
    staticClass: "pad0"
  }, [_vm._v("Forced Baptism")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. "), _c('span', {
    staticClass: "pad0"
  }, [_vm._v("Widow Waters")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. "), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("Race")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Part04#pt-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Four: Baptismal Hope")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter11#ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. "), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("Healing Waters")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter12#ch-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. "), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("One Baptism")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm1"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Epilogue#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: A Baptized Imagination")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Bibliography#bm-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-204ade19","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007_Contents.vue
// module id = 75
// module chunks = 0